import { UseQueryResult } from 'react-query';

import { BrandAffinityLevel } from 'modules/domains/brandAffinity';
import { UserId } from 'modules/domains/user';

import { AffinityCampaign, AffinityScore } from './common';

// ref https://support.iterable.com/hc/en-us/articles/205614175-Events-Overview
export enum AffinitySystemEvent {
  Send = 'send',
  Open = 'open',
  Click = 'click',
}

export interface AffinityAggregateEvent {
  compareFrom: BrandAffinityLevel | 'all';
  count: number;
  event: AffinitySystemEvent.Send | AffinitySystemEvent.Open | AffinitySystemEvent.Click;
  medianAbsolute: number;
}

export const AggregateEventOrder: Record<string, number> = {
  sends: 0,
  opens: 1,
  clicks: 2,
} as const;

export interface BrandAffinityXAI {
  computedDate: string;
  userId: UserId;
  label: BrandAffinityLevel;
  history: Array<AffinityScore>;
  topCampaigns: Array<AffinityCampaign>;
  userStats: Array<AffinityAggregateEvent>;
}

export interface BrandAffinityXAIData {
  explainBrandAffinityForUserProfile: BrandAffinityXAI;
}

export type BrandAffinityXAIResponse = UseQueryResult<BrandAffinityXAI>;

export type EngagementData = {
  count: number;
  eventType: string;
  isDefault?: boolean;
  labelCompare: AffinityAggregateEvent['compareFrom'];
  median: number;
};
